<div class="settings-user-management d-grid gap-3">
    <SettingsUserManagementHeader
        :users_count="users.length"
        :active_users_count="active_users_count"
        @open-add-user="open_add_user"
    />

    <SettingsUserManagementAlerts
        :load_error="load_error"
        :save_success="save_success"
        @clear-error="clear_load_error"
        @clear-success="clear_save_success"
    />

    <SettingsUserManagementTable
        :users="users"
        :property_options="property_options"
        :is_loading="is_loading"
        :has_users_endpoint="has_users_endpoint"
        :current_user_id="current_user_id"
        :current_user_email="current_user_email"
        @users-updated="set_users"
        @reload-users="handle_reload_users"
        @status-message="set_save_success"
        @error-message="set_load_error"
    />

    <SettingsUserManagementAddUser
        :is_open="show_add_user_modal"
        :users="users"
        :role_options="role_options"
        :property_options="property_options"
        :is_loading_roles="is_loading_roles"
        :is_loading_properties="is_loading_properties"
        @close="close_add_user_modal"
        @reload-users="handle_reload_users"
        @user-added="handle_user_added"
    />
</div>
